import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import {
  websiteActions,
  websitePagesActions,
} from 'src/app/shared/store/_features/website/website.actions';
import { selectWebsitePages } from 'src/app/shared/store/_features/website/website.selector';
import { AccountSetupHelperService } from '../account-setup-helper.service';
import { Subscription } from 'rxjs';
import { StepDefinition } from 'src/app/shared/partials/ai/step-progress-runner/step-progress-runner.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-completion-step',
  templateUrl: './completion-step.component.html',
})
export class CompletionStepComponent {
  subscriptions: Subscription[] = [];
  isHomePageDone = false;
  environment = environment;

  isComplete = false;
  constructor(
    private store: Store,
    public accountSetupHelperService: AccountSetupHelperService,
  ) {}

  SETUP_STEPS: StepDefinition[] = [
    {
      label: 'Setting up your domain',
      action: () => this.accountSetupHelperService.updateWebsiteIdentity(),
      isDone: () => true,
    },
    {
      label: 'Deploying your Website',
      action: () => {},
      isDone: () => true,
    },
    {
      label: 'Creating your Home Page',
      action: () => {},
      isDone: () => true,
    },
    {
      label: 'Crafting your Home Page Content',
      action: () => this.listenToHomePageGenerationValidation(),
      isDone: () => {
        this.reloadPages();
        return this.isHomePageDone;
      },
    },
    {
      label: 'Finalizing Setup...',
      action: () => {
        this.reloadWebsite();
      },
      isDone: () => true,
    },
  ];

  listenToHomePageGenerationValidation() {
    const sub = this.store.select(selectWebsitePages).subscribe((pages) => {
      const homePage = pages.find((p) => p.slug === 'home');
      if (homePage?.processState === 'completed') {
        this.isHomePageDone = true;
      }
    });
    this.subscriptions.push(sub);
  }

  reloadWebsite() {
    this.store.dispatch(websiteActions.load());
  }
  reloadPages() {
    this.store.dispatch(websitePagesActions.load({ withOutScreenshots: true }));
  }

  onAllDone() {
    this.isComplete = true;
  }

  navigateToDashboard() {
    this.accountSetupHelperService.wizardModel.goToNextStep();
  }
}
